/**
 * O tema global de MuiMenuItem define minWidth: 160px, o que empurra o label
 * para fora da coluna estreita (~56px) do relógio digital do DateTimePicker.
 */
const pickers = {
  MuiMultiSectionDigitalClockSection: {
    styleOverrides: {
      root: {
        "&::after": {
          display: "none",
        },
      },
      item: {
        minWidth: "unset",
        minHeight: "unset",
      },
    },
  },
  MuiDigitalClock: {
    styleOverrides: {
      item: {
        minWidth: "unset",
        minHeight: "unset",
      },
    },
  },
};

export default pickers;
